import { render, staticRenderFns } from "./SelecFiltertForEnrichData.vue?vue&type=template&id=1fffb210&scoped=true"
import script from "./SelecFiltertForEnrichData.vue?vue&type=script&lang=js"
export * from "./SelecFiltertForEnrichData.vue?vue&type=script&lang=js"
import style0 from "./SelecFiltertForEnrichData.vue?vue&type=style&index=0&id=1fffb210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fffb210",
  null
  
)

export default component.exports